import { __assign, __extends, __rest } from "tslib";
import React, { forwardRef } from "react";
import ReactDOM from "react-dom";
import { mergeRefs } from "../_util/merge-refs";
import { attachProps } from "../_util/attach-props";
var DomRefInner = /** @class */ (function (_super) {
    __extends(DomRefInner, _super);
    function DomRefInner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DomRefInner.prototype.componentDidMount = function () {
        var dom = ReactDOM.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
        var domRef = this.props.domRef;
        mergeRefs(domRef)(dom);
    };
    DomRefInner.prototype.componentDidUpdate = function () {
        var dom = ReactDOM.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
        var domRef = this.props.domRef;
        mergeRefs(domRef)(dom);
    };
    DomRefInner.prototype.componentWillUnmount = function () {
        var domRef = this.props.domRef;
        mergeRefs(domRef)(null);
    };
    DomRefInner.prototype.render = function () {
        var _a = this.props, children = _a.children, domRef = _a.domRef, props = __rest(_a, ["children", "domRef"]);
        var childrenElement = children;
        // 元素类型的，可以把要求渲染的 childrenProps 和原本的 props 合并
        if (React.isValidElement(childrenElement)) {
            return React.cloneElement(childrenElement, attachProps(childrenElement.props, props));
        }
        return children;
    };
    return DomRefInner;
}(React.Component));
export var DomRef = forwardRef(function (props, ref) { return (React.createElement(DomRefInner, __assign({}, props, { domRef: ref }))); });
//# sourceMappingURL=DomRef.js.map